"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TraineeListApi {
    constructor(customerList) {
        this.customerList = customerList;
    }
    getMembersList(application) {
        return application === "PBP"
            ? this.customerList.getCustomers().then((customers) => customers.map((customer) => ({
                member: {
                    id: customer.id,
                    firstName: customer.firstName,
                    lastName: customer.lastName,
                    email: customer.email,
                },
                id: customer.id,
            })))
            : Promise.resolve([]);
    }
}
exports.default = TraineeListApi;
//# sourceMappingURL=TraineeListApi.js.map